import styles from './MultiSelect.module.scss';

interface MultiSelectProps {
  options: { name: string; value: string }[];
  title: string;
  checkedValues: string[];
  setValue: (name: string, checked: boolean) => void;
  helperText?: string;
}

const MultiSelect = ({
  options,
  title,
  checkedValues,
  setValue,
  helperText = ''
}: MultiSelectProps) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>{title}</p>
      <ul className={styles.list}>
        {options.map(({ name, value }) => (
          <li title={name} key={value}>
            <input
              type="checkbox"
              className={styles.checkbox}
              checked={checkedValues.includes(value)}
              onChange={(e) => setValue(value, e.target.checked)}
              id={value}
              name={value}
              value={value}
            />
            <label className={styles.option} htmlFor={value}>
              <span className={styles.box} />
              <span className={styles.name}>{name}</span>
            </label>
          </li>
        ))}
      </ul>
      {helperText && <span className={styles.helperText}>{helperText}</span>}
    </div>
  );
};

export default MultiSelect;
